<div class="ti-card appearance-{{ appearance }}">
  <ng-content></ng-content>
</div>
